<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6>
          <!--<p class="font-weight-black">recuerde que nuestro horario de atencion se base en el pico y cedula propuesto por la alcaldia:
            <li v-for="p in pico">
              {{ p.dia }} - Cedulas Terminadas {{ p.digito }}
            </li>
          </p>-->
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Ingrese número de documento (trabajador), celular y email</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form ref="form" @submit.prevent="handleSubmit">
                <v-text-field
                    v-model="documento"
                    :rules="documentoRules"
                    id="documento"
                    prepend-icon="person"
                    name="documento"
                    label="Documento"
                    type="number"
                    autocomplete>
                </v-text-field>
                <v-text-field
                    v-model="celular"
                    :rules="celularRules"
                    id="celular"
                    prepend-icon="phone"
                    name="celular"
                    label="Celular"
                    type="number"
                    autocomplete>
                </v-text-field>
                <v-text-field
                    v-model="email"
                    id="email"
                    prepend-icon="email"
                    :rules="emailRules"
                    name="email"
                    label="Email"
                    type="email"
                    autocomplete>
                </v-text-field>

              </v-form>
            </v-card-text>
            <v-card-actions class="px-5">
               <v-layout row>
              <v-flex xs12 md6>
                  <v-btn outline block @click="submit" :disabled="!valid" color="primary">
                    Continuar
                  </v-btn>
                </v-flex>
               <v-flex xs12 md6>   
                  <v-btn outline block @click="devolver"  color="primary" >
                    Devolver
                  </v-btn>
                  
              </v-flex>
            </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import {turnoService} from "../services/turnoService"
  import {router} from '../router';
  export default {
    data: () => ({
      pico: null,
      celular: '',
      documento: '',
      email: '',
      emailRules: [
        v => !!v || 'Debe ingresar el correo electronico',
      ],
      documentoRules: [
        v => !!v || 'Debe ingresar su número de documento',
      ],

      celularRules: [
        v => v.length == 10 || 'Debe ingresar un número de celular valido',
      ],
      valid: true,
      info: []
    }),
    created() {
      turnoService.getHorarioAtencion().then(data => 
          localStorage.setItem('horario', JSON.stringify(data))
       )
      localStorage.setItem('inte',null);
    },
    methods: {
      submit() {
        console.log(this.email.length);
        if(this.email.length>0){
          if (!this.validEmail(this.email)){
            alert("debe ingresar un correo valido");
            return ;
          }
        }else{
          alert("digite el correo electronico");
          
        }
        if(this.celular.length!=10){
         alert("digite un numero de celular valido"); 
         return false;
        }
        if (this.documento && this.celular && this.email) {
          this.$store.state.turnos.all = [];          
          this.info.push({
            documento: this.documento,
            celular: this.celular,
            email: this.email
          });
          
          /*let lastdigit = this.documento.slice(-1); 
          let dia = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado","Domingo"];
          
          this.pico.forEach(function (value) {
              let digitos = value.digito.split(',');
              digitos.forEach(function(val){
                  if(lastdigit == val){
                    dia = dia.indexOf(value.dia);

                  }
              });
          });


          localStorage.setItem('horario',JSON.stringify(dia));
          */
          turnoService.verificarCategoria(this.info).then(
          data => {
                if(data.data.state==200){
                    localStorage.setItem('inte',JSON.stringify(Object.assign({}, this.info[0], data.data)));
                    router.push('/reservacion/teyuna');    
                }else{
                    this.flashMessage.show({status: 'warning', title: 'Información', message: data.data.msj, time:9000})
                    setTimeout(function(){
                      localStorage.setItem('inte',null);
                      router.push('/');    
                    }, 9000); 
                    
                }
              },
              error => {
                console.log("error saving...");
                return false;
              }
            );
        }else{

        }
      },
      devolver() {
          router.push('/');
      },
      validEmail: function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    },
    components: {
      VueRecaptcha
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Teyuna.vue